import(/* webpackMode: "eager" */ "/codebuild/output/src2512230122/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
